module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Image.js"));
	}, "Image");
}